module.exports = __webpack_public_path__ + "media/images/banner/area/feature/gunma-3de9771826ec4d2a193bb24f867891dc.png";